import { PanelRightClose, ChevronsLeft } from "lucide-react";

// Slim tab pinned to the map's right edge: collapses / restores the observations panel.
export const PanelEdgeToggle = ({ collapsed, onToggle, count = 0 }) => (
  <button
    type="button"
    onClick={onToggle}
    data-testid="layout-toggle"
    aria-label={collapsed ? "Show observations panel" : "Full-screen map"}
    title={collapsed ? "Show observations" : "Full-screen map"}
    className={`group absolute right-0 top-1/2 -translate-y-1/2 z-[1000] flex flex-col items-center backdrop-blur border border-r-0 transition-[background-color,color,box-shadow,padding] duration-200 ${
      collapsed
        ? "atlas-edge-pulse gap-2.5 py-4 px-2 bg-atlas-cyan/15 border-atlas-cyan/70 text-atlas-cyan hover:bg-atlas-cyan/25 hover:pr-3 shadow-[0_0_18px_rgba(0,229,255,0.35)]"
        : "gap-2 py-3 px-1.5 bg-atlas-void/80 border-white/10 text-atlas-secondary hover:text-atlas-cyan hover:bg-atlas-void"
    }`}
  >
    {collapsed ? <ChevronsLeft className="w-4 h-4 transition-transform duration-200 group-hover:-translate-x-0.5" strokeWidth={2} /> : <PanelRightClose className="w-3.5 h-3.5" strokeWidth={1.8} />}
    {collapsed && (
      <span
        className="text-[10px] font-mono font-semibold uppercase tracking-[0.2em] [writing-mode:vertical-rl] rotate-180"
        data-testid="layout-toggle-label"
      >
        Incidents · {count}
      </span>
    )}
  </button>
);
